import { render, staticRenderFns } from "./BannerEditDialog.vue?vue&type=template&id=0bd199be"
import script from "./BannerEditDialog.vue?vue&type=script&lang=js"
export * from "./BannerEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports